<div class="date">{{page.publishedAt | date : 'dd.MM.yy'}}</div>
<div class="name">
    <h1>{{page.name}}</h1>
</div>

    <div class="intro" *ngIf="!page.isBlank">
      <div *ngIf="posters.length===1" class="pub-poster">
        <img [src]="poster" alt="">
      </div>
      <p class="excerpt" *ngIf="page.excerpt">{{page.excerpt}}</p>
      <p class="intro-text" *ngIf="page.introText">{{page.introText}}</p>

        
      <swiper-gallery *ngIf="posters?.length > 1" [items]="posters" ></swiper-gallery>
    </div>
    <!-- <pre>{{posters|json}}</pre> -->
    <div class="content" *ngIf="page.content" [innerHTML]="page.content"></div>
    <page-sections [page]="page" [editMode]="editMode" [modelType]="'publication'"></page-sections>

    <a (click)="back()" class="publication-page-back">
      <ico ico="chevron_left_24"></ico>
      Назад      
    </a>

